import { withInstall } from '@tav-ui/utils/with-install'
import VirtualScroll from './src/virtual-scroll'
const TaVirtualScroll = withInstall(VirtualScroll)
export { TaVirtualScroll }
export default TaVirtualScroll
export * from './src/types'
